import React, { useEffect, useState } from 'react';
import { CountrySelector } from './CountrySelector';
import { SaveIcon } from 'lucide-react';
export function AddressForm({
  address,
  onSave,
  onCancel,
  locale
}) {
  const [formData, setFormData] = useState({
    id: '',
    line1: '',
    line2: '',
    city: '',
    state: '',
    postcode: '',
    country: '',
    addressType: 'Physical',
    isPrimary: false
  });
  useEffect(() => {
    if (address) {
      setFormData({
        ...address
      });
    } else {
      setFormData({
        id: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        postcode: '',
        country: '',
        addressType: 'Physical',
        isPrimary: false
      });
    }
  }, [address]);
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };
  const handleCountryChange = countryCode => {
    setFormData({
      ...formData,
      country: countryCode
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    onSave(formData);
  };
  return <div className="bg-white shadow sm:rounded-lg" data-id="element-16454">
      <div className="px-4 py-5 sm:p-6" data-id="element-16455">
        <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-16456">
          {address ? 'Edit Address' : 'Add Address'}
        </h3>
        <form className="mt-5 space-y-6" onSubmit={handleSubmit} data-id="element-16457">
          <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6" data-id="element-16458">
            <div className="sm:col-span-6" data-id="element-16459">
              <label htmlFor="line1" className="block text-sm font-medium text-gray-700" data-id="element-16460">
                Address Line 1
              </label>
              <div className="mt-1" data-id="element-16461">
                <input type="text" name="line1" id="line1" value={formData.line1} onChange={handleChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" required data-id="element-16462" />
              </div>
            </div>
            <div className="sm:col-span-6" data-id="element-16463">
              <label htmlFor="line2" className="block text-sm font-medium text-gray-700" data-id="element-16464">
                Address Line 2
              </label>
              <div className="mt-1" data-id="element-16465">
                <input type="text" name="line2" id="line2" value={formData.line2} onChange={handleChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-16466" />
              </div>
            </div>
            <div className="sm:col-span-3" data-id="element-16467">
              <label htmlFor="city" className="block text-sm font-medium text-gray-700" data-id="element-16468">
                City
              </label>
              <div className="mt-1" data-id="element-16469">
                <input type="text" name="city" id="city" value={formData.city} onChange={handleChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" required data-id="element-16470" />
              </div>
            </div>
            <div className="sm:col-span-3" data-id="element-16471">
              <label htmlFor="state" className="block text-sm font-medium text-gray-700" data-id="element-16472">
                State/Province/Region
              </label>
              <div className="mt-1" data-id="element-16473">
                <input type="text" name="state" id="state" value={formData.state} onChange={handleChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-16474" />
              </div>
            </div>
            <div className="sm:col-span-3" data-id="element-16475">
              <label htmlFor="postcode" className="block text-sm font-medium text-gray-700" data-id="element-16476">
                Postcode/ZIP
              </label>
              <div className="mt-1" data-id="element-16477">
                <input type="text" name="postcode" id="postcode" value={formData.postcode} onChange={handleChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" required data-id="element-16478" />
              </div>
            </div>
            <div className="sm:col-span-3" data-id="element-16479">
              <label htmlFor="country" className="block text-sm font-medium text-gray-700" data-id="element-16480">
                Country
              </label>
              <div className="mt-1" data-id="element-16481">
                <CountrySelector value={formData.country} onChange={handleCountryChange} locale={locale} data-id="element-16482" />
              </div>
            </div>
            <div className="sm:col-span-3" data-id="element-16483">
              <label htmlFor="addressType" className="block text-sm font-medium text-gray-700" data-id="element-16484">
                Address Type
              </label>
              <div className="mt-1" data-id="element-16485">
                <select id="addressType" name="addressType" value={formData.addressType} onChange={handleChange} className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" data-id="element-16486">
                  <option value="Physical" data-id="element-16487">Physical</option>
                  <option value="Postal" data-id="element-16488">Postal</option>
                  <option value="Billing" data-id="element-16489">Billing</option>
                  <option value="Shipping" data-id="element-16490">Shipping</option>
                  <option value="Other" data-id="element-16491">Other</option>
                </select>
              </div>
            </div>
            <div className="sm:col-span-3" data-id="element-16492">
              <div className="flex items-center h-full" data-id="element-16493">
                <input id="isPrimary" name="isPrimary" type="checkbox" checked={formData.isPrimary} onChange={handleChange} className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded" data-id="element-16494" />
                <label htmlFor="isPrimary" className="ml-2 block text-sm text-gray-700" data-id="element-16495">
                  Is Primary Address
                </label>
              </div>
            </div>
          </div>
          <div className="flex justify-end space-x-3" data-id="element-16496">
            <button type="button" onClick={onCancel} className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-16497">
              Cancel
            </button>
            <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-16498">
              <SaveIcon className="h-4 w-4 mr-2" data-id="element-16499" />
              Save Address
            </button>
          </div>
        </form>
      </div>
    </div>;
}